// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nR-SI","footer":"styles_footer__2ngwe","passCodeTooltip":"styles_passCodeTooltip__3_78g"};